// src/components/Settings/Promotion/PromotionDashboard.js
import React, { useState, useEffect, useCallback } from "react";
import "./PromotionDashboard.scss";
import Boost from "./Boost";
import Ads from "./Ads";

import DynamicHeader from "../../Header/DynamicHeader";

import raiseIcon from "../img/promotion.png";
import adsIcon from "../img/statistics.png";

import comingSoon from "../img/cvantik-coming-soon.png";

import Wallet from "./Wallet";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";
import { getAccessToken } from "../../../awsAuth";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5000";

const PromotionDashboard = () => {
  const [tab, setTab] = useState("boost");

  const { isLoggedIn, userId } = useAuth();

  const [isWalletOpen, setIsWalletOpen] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const [walletLoading, setWalletLoading] = useState(false);

  const openWallet = () => setIsWalletOpen(true);
  const closeWallet = () => setIsWalletOpen(false);

  const fetchWallet = useCallback(async () => {
    if (!isLoggedIn || !userId) {
      setWalletBalance(0);
      return;
    }

    try {
      setWalletLoading(true);
      const r = await axios.get(`${API_BASE}/api/account/${userId}/wallet`);
      const coins = Number(r?.data?.walletCoins || 0);
      setWalletBalance(Number.isFinite(coins) ? coins : 0);
    } catch (e) {
      console.warn("[PromotionDashboard] wallet fetch failed:", e?.message || e);
      setWalletBalance(0);
    } finally {
      setWalletLoading(false);
    }
  }, [isLoggedIn, userId]);

  useEffect(() => {
    fetchWallet();
  }, [fetchWallet]);

  const handleTopup = async (coins) => {
    const c = Number(coins) || 0;
    if (!c) return;

    if (!isLoggedIn || !userId) return;

    try {
      setWalletLoading(true);
      const token = await getAccessToken?.().catch(() => null);
      const r = await axios.post(
        `${API_BASE}/api/account/${userId}/wallet/topup`,
        { amount: c },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const coinsAfter = Number(r?.data?.walletCoins || 0);
      setWalletBalance(Number.isFinite(coinsAfter) ? coinsAfter : walletBalance);
    } catch (e) {
      console.warn("[PromotionDashboard] wallet topup failed:", e?.message || e);
    } finally {
      setWalletLoading(false);
    }
  };

  return (
    <>
      {}
      <DynamicHeader
        title="Просування та підняття"
        variant="glass"
        size="regular"
        showBack
        withSpacer
      />

      <div className="promotion">
        <div className="promotion-header">
          <div className="promotion-header__left">
            <h1>Просування та підняття</h1>
            <p className="subtitle">
              Керуйте підняттям оголошень та майбутніми рекламними кампаніями Cvanto Ads.
            </p>
          </div>

          <div className="promotion-header__right">
            <button
              className="wallet-button"
              onClick={openWallet}
              disabled={!isLoggedIn || !userId}
              title={!isLoggedIn ? "Увійдіть, щоб бачити гаманець" : ""}
            >
              <span className="wallet-button__title">Гаманець</span>
              <span className="wallet-button__sub">
                Ваш баланс:{" "}
                <b>{walletLoading ? "..." : walletBalance}</b> Tokens
              </span>
            </button>
          </div>
        </div>

        <div className="promotion-tabs">
          <button
            className={`tab ${tab === "boost" ? "active" : ""}`}
            onClick={() => setTab("boost")}
          >
            <img src={raiseIcon} alt="" />
            <span>Підняття</span>
          </button>

          <button
            className={`tab ${tab === "ads" ? "active" : ""}`}
            onClick={() => setTab("ads")}
          >
            <img src={adsIcon} alt="" />
            <span>Cvanto Ads</span>
          </button>
        </div>

        <div className="promotion-body">
          {tab === "boost" ? <Boost onWalletRefresh={fetchWallet} /> : <Ads />}

          {}
        </div>
      </div>

      {isWalletOpen && (
        <Wallet
          isLoggedIn={!!isLoggedIn}
          userId={userId}
          balance={walletBalance}
          loading={walletLoading}
          onClose={closeWallet}
          onTopup={handleTopup}
          onRefresh={fetchWallet}
        />
      )}
    </>
  );
};

export default PromotionDashboard;
